import React, {useEffect, useState} from 'react';
import OdxModal from "../../../../OdxComponents/NativeOdx/Modal/Odx-Modal";
import OdxInputField from "../../../../OdxComponents/NativeOdx/FormControls/Odx-InputField";
import {odxIconSets} from "../../../../OdxComponents/constants";
import {HubPathRouting} from "../../../../HubFramework/pathBuilder";
import {updateApiKeys} from "../../BackendFacade/apiCalls";
import {useMain} from "../../../../Utils/SessionControls/mainContext";
import {TenantLine} from "../../../IDMS/Interfaces/ITenantSystem";
import {defaultAuth} from "../../constants";
import {OdxInputError} from '../../../../OdxComponents/NativeOdx/FormControls/Interfaces';
import {IApiKey, IApiKeyContentTypes} from "../../Interfaces/IApiKeyManagement";
import {formatDateToBackend} from "../../../../Utils/transformer";
import {IApiKeysAddEditState} from "../../Interfaces/IApiKeysAddEditState";
import {ScopeType} from "../../../IDMS/Utils/tenantSystem";
import OdxCheckbox from "../../../../OdxComponents/NativeOdx/FormControls/Odx-Checkbox";
import AddEditScopeModal from "../../../IDMS/Tabs/Modals/AddEditScopeModal";
import ApiKeyField from "../../Components/ApiKeyField";
import OdxDatepicker from "../../../../OdxComponents/NativeOdx/FormControls/Odx-Datepicker";
import ModalTenantManagementTable from "../../../../OdxComponents/CustomOdx/ModalTenantManagementTable";
import DeleteApiKeyModal from "./DeleteApiKeyModal";
import OdxFormfield from "../../../../OdxComponents/NativeOdx/FormControls/Odx-Formfield";

interface AddApiKeyModalProps {
    toggleOpen: () => void;
    closeFunction: () => void;
    onSuccessFunction: () => void;
    projectId: string;
    selectedValue: IApiKeysAddEditState;
}

    const ApiKeysEditModal: React.FC<AddApiKeyModalProps> = ({
                                                                 toggleOpen,
                                                                 closeFunction,
                                                                 onSuccessFunction,
                                                                 projectId,
                                                                 selectedValue,
                                                             }) => {
    const baseId = 'hub-edit-api-key';
        const [Selected_Value, setSelected_Value] = useState<IApiKey>(selectedValue.Selected_Value);
        const [tenantSystem, setTenantSystem] = useState<TenantLine[]>(selectedValue.tenantSystem || []);
    const [validUntil, setValidUntil] = useState<string>(Selected_Value.validUntil || "");
    const [editingScope, setEditingScope] = useState<TenantLine | null>(null);
    const [emailError, setEmailError] = useState<OdxInputError | string>("");
    const [isAddScopeSideSheetOpen, setIsAddScopeSideSheetOpen] = useState(false);
    const [currentProject, setCurrentProject] = useState<string>(projectId);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

    const {setLoading, createToast, createErrorToast} = useMain();

    useEffect(() => {
        if (Selected_Value.contentType === IApiKeyContentTypes.hubIdmsTenantJson &&
            tenantSystem.length <= 1 &&
            HubPathRouting.currentProject &&
            tenantSystem[0]?.fullscope.indexOf(HubPathRouting.currentProject.id) === -1) {
            addGlobalScope();
        }
    }, []);

    const addGlobalScope = () => {
        let scopes = [...tenantSystem];
        let newLine: TenantLine = {id: scopes.length, scopes: ["user"], value: defaultAuth, tmp: "", fullscope: "user"};
        if (projectId !== "null") {
            newLine.scopes.push(projectId);
        }
        scopes.push(newLine);
        setTenantSystem(scopes);
        return scopes;
    };

    const saveKey = async () => {
        setLoading(true);
        if (Selected_Value.contentType === IApiKeyContentTypes.hubIdmsTenantJson) {
            let tenantData: { [key: string]: string } = {};
            for (let line of tenantSystem) {
                if (line.value === "-" || line.scopes.length === 0 || line.value === "") {
                    continue;
                }
                tenantData[line.scopes.join('/')] = line.value;
            }
            Selected_Value.content = JSON.stringify(tenantData);
        }

        if (validUntil !== "") {
            Selected_Value.validUntil = formatDateToBackend(validUntil);
        } else {
            Selected_Value.validUntil = "";
        }

        updateApiKeys(projectId, Selected_Value).then((data) => {
            setLoading(false);
            if (data.success) {
                onSuccessFunction();
                createToast({message: "API Key saved successfully", variant: "success", title: "Success"});
            } else {
                createErrorToast("Error while saving API key: " + data.message);
            }
        });
    };

    const removeScope = (index: number) => {
        setTenantSystem(tenantSystem.filter((scope, i) => i !== index));
    };

    const openEditScopeModal = (scope: TenantLine) => {
        setEditingScope(scope);
        setIsAddScopeSideSheetOpen(true);
    };

    const handleAddScope = (newScope: TenantLine) => {
        if (editingScope) {
            const updatedScopes = tenantSystem.map(scope => scope.id === editingScope!.id ? newScope : scope);
            setTenantSystem(updatedScopes);
        } else {
            setTenantSystem([...tenantSystem, newScope]);
        }
        setEditingScope(null);
        setIsAddScopeSideSheetOpen(false);
    };

    const handleDelete = () => {
        setIsDeleteModalOpen(true);
    };

    const closeDeleteModal = () => {
        setIsDeleteModalOpen(false);
        closeFunction();
    };

    return (<>
        {isDeleteModalOpen && <DeleteApiKeyModal
            closeFunction={closeDeleteModal}
            onSuccessFunction={onSuccessFunction}
            apiKey={Selected_Value}
            currentProject={projectId}
        />}
        {isAddScopeSideSheetOpen && <AddEditScopeModal
            onClose={() => {
                setIsAddScopeSideSheetOpen(false);
                setEditingScope(null);
            }}
            onAddScope={handleAddScope}
            initialScope={editingScope}
            isEditMode={!!editingScope}
            globalScope={editingScope?.fullscope === 'user'}
            scopeType={ScopeType.Hub}
        />}
        <OdxModal
            size="small"
            title={"Edit Api Key"}
            onClose={toggleOpen}
            isOpen={!isAddScopeSideSheetOpen}
            variant="sidesheet"
            id={baseId}
            footerButtons={[
                <odx-button
                    key="delete"
                    id={`OdxButton_${baseId}-delete-btn`}
                    variant="danger"
                    size="lg"
                    type="button"
                    onClick={handleDelete}
                >
                    Delete
                </odx-button>,
                <odx-button
                    key="save"
                    id={`OdxButton_${baseId}-save-btn`}
                    variant="primary"
                    size="lg"
                    type="button"
                    onClick={() => saveKey()}
                >
                    Save
                </odx-button>
            ]}
        >
            <div id={`${baseId}-content`}>
                <div className={"mt-[10px] mb-[10px]"} id={`${baseId}-primary-label`}>Key 1</div>
                <div>
                    <ApiKeyField keyString={Selected_Value.primaryApiKey} idPrefix={`${baseId}-primary-key`}/>
                </div>
                <div className={"mt-[10px] mb-[10px]"} id={`${baseId}-secondary-label`}>Key 2</div>
                <div>
                    <ApiKeyField keyString={Selected_Value.secondaryApiKey} idPrefix={`${baseId}-secondary-key`}/>
                </div>

                <OdxInputField
                    isRequired={true}
                    id={`${baseId}-name`}
                    label={'Name'}
                    value={Selected_Value.displayName}
                    onChange={(event) => {
                        const newValue = event.target.value;
                        setSelected_Value(prevState => ({
                            ...prevState,
                            displayName: newValue
                        }));
                    }}
                />
                <OdxDatepicker isRequired={false} index={`${baseId}-expiration`} label={"Expiration Date"} value={validUntil}
                               setValue={setValidUntil}/>
                <odx-separator id={`${baseId}-separator-top`} style={{margin: '1rem 0'}} />
                <OdxCheckbox label={"TenantSystem"}
                             id={`${baseId}-tenant-toggle`}
                             checked={Selected_Value.contentType === IApiKeyContentTypes.hubIdmsTenantJson}
                             onChange={(event) => {
                                 setSelected_Value(prevState => ({
                                     ...prevState,
                                     contentType: event.target.checked ? IApiKeyContentTypes.hubIdmsTenantJson : IApiKeyContentTypes.custom
                                 }));
                             }}
                />
                <odx-separator id={`${baseId}-separator-bottom`} style={{margin: '1rem 0'}} />

                {Selected_Value.contentType === IApiKeyContentTypes.hubIdmsTenantJson && (
                    <>
                        <ModalTenantManagementTable scopes={tenantSystem} openEditScopeModal={openEditScopeModal}
                                                    removeScope={removeScope}/>
                        {!editingScope && (
                            <odx-button
                                variant="ghost"
                                size="sm"
                                type="button"
                                onClick={() => setIsAddScopeSideSheetOpen(true)}
                                id={`OdxButton_${baseId}-add-scope-btn`}
                            >
                                <odx-icon slot="prefix" name={`${odxIconSets.core}::plus`} size="sm"></odx-icon>
                                Add Scope
                            </odx-button>
                        )}
                    </>
                )}
                {Selected_Value.contentType !== IApiKeyContentTypes.hubIdmsTenantJson && (
                    <>
                        <OdxFormfield isRequired={true}
                                      index={`${baseId}-custom-scope`}
                                      label={"Role"}
                                      value={Selected_Value.content}
                                      onChange={(event) => {
                                          const newValue = event.target.value;
                                          setSelected_Value(prevState => ({
                                              ...prevState,
                                              content: newValue
                                          }));
                                      }}/>
                    </>
                )}
            </div>
        </OdxModal>
    </>);
};

export default ApiKeysEditModal;
